import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { GET_SELLER_INFOS } from 'Store/seller/sellerInfoReducer';
const sellerInfoQuery = `{
  sellerInfo {
    email
    salesmanID
  }
}`;
export const InitializeSellerInfos = ({ appContext }: { appContext: AppContext }) => {
  const { isCmta, cmta, isIndirectCxo, cxoQueryParams } = appContext;
  // initializes CMTA and CxoIndirect email & salesmanID in Redux store
  const sellerInfo = useSelector((state) => state.seller.sellerInfo);
  const dispatch = useDispatch();
  useEffect(() => {
    if ((isCmta || isIndirectCxo) && (!sellerInfo.email || !sellerInfo.salesmanID)) {
      // if sellerInfo is not initialized in the store
      const { email, salesmanID: cmtaSalesmanID } = cmta;
      const salesmanID = isCmta ? cmtaSalesmanID : cxoQueryParams.salesman_code;

      if (email || salesmanID) {
        // no need to make a call if we have sellerInfo in the context
        dispatch({
          type: GET_SELLER_INFOS,
          payload: {
            sellerInfo: {
              email,
              salesmanID,
            },
          },
        });
      } else {
        graphQLClient.runNoCacheQuery(sellerInfoQuery, appContext).then((data) => {
          dispatch({
            type: GET_SELLER_INFOS,
            payload: data,
          });
        });
      }
    }
  }, []);
  return null;
};
